
const DocIcon = ({ width = "40", height = "40", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="20"
        cy="20"
        r="19.4444"
        fill="white"
        stroke="#EDEBEC"
        strokeWidth="1.11111"
      />
      <path
        d="M23.7161 24.2234H16.4961"
        stroke="#00A7E4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7161 20.0369H16.4961"
        stroke="#00A7E4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2511 15.8601H16.4961"
        stroke="#00A7E4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9085 10.7498C23.9085 10.7498 16.2315 10.7538 16.2195 10.7538C13.4595 10.7708 11.7505 12.5868 11.7505 15.3568V24.5528C11.7505 27.3368 13.4725 29.1598 16.2565 29.1598C16.2565 29.1598 23.9325 29.1568 23.9455 29.1568C26.7055 29.1398 28.4155 27.3228 28.4155 24.5528V15.3568C28.4155 12.5728 26.6925 10.7498 23.9085 10.7498Z"
        stroke="#0069AD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocIcon;